import { render, staticRenderFns } from "./MinorPurchase.vue?vue&type=template&id=07bd5ed6&scoped=true&"
import script from "./MinorPurchase.vue?vue&type=script&lang=ts&"
export * from "./MinorPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd5ed6",
  null
  
)

export default component.exports